import React from 'react'

const RegisterUser = () => {
  return (
    <div>
      
    </div>
  )
}

export default RegisterUser
